var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame1261153744AboutPg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 72,
    viewBox: "0 0 197 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7228 -40.4493C56.092 -44.3665 58.7616 -48.1026 62.7274 -48.2242C72.4415 -48.522 82.1099 -46.2723 90.7482 -41.6402C101.507 -35.8711 110.071 -26.7263 115.124 -15.6131C120.177 -4.49993 121.437 7.96569 118.712 19.8654C115.986 31.765 109.425 42.4393 100.039 50.2453C90.6535 58.0514 78.9623 62.5567 66.7652 63.0679C54.5681 63.579 42.541 60.0677 32.5348 53.0743C22.5286 46.0809 15.0979 35.9931 11.3863 24.3632C8.4061 15.0253 7.95614 5.10885 10.0194 -4.38825C10.8617 -8.26546 15.0218 -10.2095 18.7584 -8.87532C22.4951 -7.54115 24.3748 -3.42932 23.7073 0.481775C22.6002 6.9677 23.0527 13.6606 25.0742 19.9947C27.8281 28.6237 33.3415 36.1086 40.7657 41.2975C48.19 46.4863 57.1137 49.0916 66.1636 48.7123C75.2135 48.3331 83.8879 44.9903 90.852 39.1984C97.8161 33.4066 102.684 25.4866 104.706 16.6575C106.728 7.82829 105.793 -1.4208 102.044 -9.66641C98.2955 -17.912 91.9408 -24.6972 83.9582 -28.9777C78.0986 -32.1197 71.6003 -33.7844 65.0212 -33.878C61.054 -33.9345 57.3536 -36.5321 56.7228 -40.4493Z",
    fill: "url(#paint0_linear_2224_29296)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5132 -62.3824C39.2452 -64.2717 51.273 -62.2532 61.7455 -56.6375C72.2181 -51.0218 80.5549 -42.1202 85.4731 -31.3026C90.3913 -20.485 91.6183 -8.35094 88.9652 3.23226C86.3121 14.8155 79.926 25.2058 70.7897 32.8043C61.6533 40.4027 50.2731 44.7882 38.4004 45.2858C26.5277 45.7833 14.8204 42.3654 5.08035 35.558C-4.65971 28.7506 -11.8928 18.931 -15.5057 7.61044C-19.1187 -3.71016 -18.9113 -15.9044 -14.9154 -27.0955L-9.69737 -25.2324C-13.2848 -15.1852 -13.471 -4.23753 -10.2274 5.92586C-6.98373 16.0893 -0.490035 24.9051 8.25438 31.0166C16.9988 37.1281 27.5093 40.1967 38.1684 39.7499C48.8275 39.3032 59.0444 35.3661 67.2468 28.5443C75.4492 21.7226 81.1825 12.3944 83.5644 1.99523C85.9463 -8.40392 84.8447 -19.2976 80.4293 -29.0095C76.0138 -38.7213 68.5292 -46.7129 59.1272 -51.7545C49.7252 -56.7962 38.9269 -58.6083 28.3941 -56.9122L27.5132 -62.3824Z",
    fill: "url(#paint1_linear_2224_29296)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2224_29296",
    x1: 73.2868,
    y1: 62.4084,
    x2: 55.5807,
    y2: -47.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B43EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C056C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2224_29296",
    x1: 112.479,
    y1: -76.418,
    x2: 86.7206,
    y2: 68.2493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1261153744AboutPg);
export default __webpack_public_path__ + "static/media/frame_1261153744_about_pg.a7f3979addf3857d1368436250af7d7e.svg";
export { ForwardRef as ReactComponent };